import {postMethod} from '@/api'

export const post = async request => await postMethod('/proxy/mail', request)
